import { render, staticRenderFns } from "./HodOnboardingMatchingRoot.vue?vue&type=template&id=41295b79&scoped=true&"
import script from "./HodOnboardingMatchingRoot.vue?vue&type=script&lang=ts&"
export * from "./HodOnboardingMatchingRoot.vue?vue&type=script&lang=ts&"
import style0 from "./HodOnboardingMatchingRoot.vue?vue&type=style&index=0&id=41295b79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41295b79",
  null
  
)

export default component.exports